import { ECOM_PLATFORM_APP_DEF_ID } from './consts';
export class ViewerContext {
  constructor(controllerConfig, siteStore) {
    this.controllerConfig = controllerConfig;
    this.siteStore = siteStore;
  } //
  isExperimentEnabled(key) {
    if (this.siteStore) {
      return this.siteStore.experiments.enabled(key);
    }
    return this.controllerConfig.essentials.experiments.enabled(key);
  }
  isSSR() {
    if (this.siteStore) {
      return this.siteStore.isSSR();
    }
    return this.controllerConfig.wixCodeApi.window.rendering.env === 'backend';
  }
  getDeviceType() {
    if (this.siteStore) {
      return this.siteStore.formFactor;
    }
    return this.controllerConfig.wixCodeApi.window.formFactor;
  }
  getViewMode() {
    if (this.siteStore) {
      return this.siteStore.viewMode;
    }
    return this.controllerConfig.wixCodeApi.window.viewMode;
  }
  isPrimaryLanguage() {
    if (this.siteStore) {
      const multiLangFields = this.siteStore.getMultiLangFields();
      return Boolean(!multiLangFields || multiLangFields.isPrimaryLanguage);
    }
    const currentLang = this.controllerConfig.wixCodeApi.window.multilingual.siteLanguages.find(lang => lang.languageCode === this.controllerConfig.wixCodeApi.window.multilingual.currentLanguage);
    return !currentLang || currentLang.isPrimaryLanguage;
  }
  getCurrentLanguage() {
    if (this.siteStore) {
      var _this$siteStore$getMu;
      return ((_this$siteStore$getMu = this.siteStore.getMultiLangFields()) == null ? void 0 : _this$siteStore$getMu.lang) || 'en';
    }
    return this.controllerConfig.wixCodeApi.window.multilingual.currentLanguage;
  }
  getEcomPlatformInstanceId() {
    if (this.siteStore) {
      return this.siteStore.storeId;
    }
    return this.controllerConfig.appParams.instanceId;
  }
  getEcomPlatformPublicAPI() {
    return this.controllerConfig.wixCodeApi.site.getPublicAPI(ECOM_PLATFORM_APP_DEF_ID);
  }
}
//# sourceMappingURL=ViewerContext.js.map